export const originalOrder = (): number => 0;
